import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
export const ButtonGroup = (props) => {
  const { vertical, minimal, className, children } = props;
  const buttonGroupClasses = classNames(
    "at-button-group",
    {
      "at-minimal": minimal,
      "at-vertical": vertical,
    },
    className
  );
  return <div className={buttonGroupClasses}>{children}</div>;
};
ButtonGroup.propTypes = {
  vertical: PropTypes.bool,
  minimal: PropTypes.bool,
  className: PropTypes.string,
};
ButtonGroup.defaultProps = {
  vertical: false,
  minimal: false,
};
